import NutritionExchanges from './NutritionExchanges';

export default NutritionExchanges;
